require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./basics-guide-marko.json") })
        }
      }, "path---basics-guide-marko");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---basics-guide-marko!./.cache/json/basics-guide-marko.json
// module id = 404
// module chunks = 231608221292675